const KaikasMatchChainIdAndNetworkName = (chainId: string) => {
  if (chainId == "1001") {
    return "BAOBAB";
  } else if (chainId == "8217") {
    return "KLAYTN";
  }
};

export default KaikasMatchChainIdAndNetworkName;
